import React, { useState, useEffect } from "react";

import { AlertMessage } from "components";

import { func_validation } from "functions";

export function useErrorHandling(props) {
    const {
        addUser_errorMsg,
        isFormSubmissionAttempted
    } = props;

    // States
    const [alertMsg, setAlertMsg] = useState("");
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);

    function handleError(errorMsg) {
        if (func_validation.isStringTrimNotEmpty(errorMsg) && 
            isFormSubmissionAttempted) {

            setAlertMsg(errorMsg);
            setIsAlertMsgVisible(true);
        }
    }
    useEffect(() => {
        handleError(addUser_errorMsg);
    }, [addUser_errorMsg]);

    let alertDisplay = (
        <AlertMessage
            message={alertMsg}
            isVisible={isAlertMsgVisible}
            toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
        />
    )

    return {
        alertDisplay
    }
}